import React from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { useState, useRef , useEffect} from 'react';
import {isMobileOnly, isIOS} from 'react-device-detect';
import { remove, uniq, filter, forEach, findIndex } from 'lodash';

const MyEsPopupCartStep4Block = styled.div`
    position: fixed;
    //background-color: rgba(17, 17, 17, 0.3);
    
    z-index: 100;
    ${isMobileOnly?`
    width: 100vw; 
    `:`
    width: 100%;
    height: 100%;
    `};
    
    ${isMobileOnly?`
    bottom: 0;
    transform: translateY(100vh);
    transition: transform 0.3s ease,opacity 0.3s ease;
    `:`
    top: 0;
    //left: -100%;
    transform: translateX(-100%);
    transition: transform 0.3s ease,opacity 0.3s ease;
    width: 100%;
    `};

    .close-pop {
        ${isMobileOnly?`
        height: calc(100vh - 475px);
        width: 100wh;  
        `:`
        //height: 100vh;
        width: calc(100% - 435px);
        `};
    }

    &.active {
        //display: block;
        
        ${isMobileOnly?`
        transform: translateY(0px);
        height: 100vh; 
        `:`
        transform: translateX(0);
        width: 100%;
        `};
    }

    &.active-no {
        
        ${isMobileOnly?`
        transform: translateY(100vh);
        //height: 0vh;
        height: 100vh;
        `:`
        transform: translateX(-100%);
        //height: 0vh;
        width: 100%;
        `};
    }

    &.hide {
        display:none;
    }

    .cate {
        
    }

`;



const MyEsPopupCartStep4ContainerBlock = styled.div`
    ${isMobileOnly?`
    height: 475px;
    `:`
    //height: 650px;
    `};
    
    color: #111111;
    position: relative;
    //top: calc(100vh - 500px);

    .top-blank {
        height: 10px;
        width: 100vw;
    }
    .top-bar {
        border-radius: 4px;
        background-color: #ffffff;
        width: 50px;
        height: 8px;
        margin: 0 auto;
        margin-bottom: 10px;
    }
    .container {
        ${isMobileOnly?`
        background-color: #ffffff;
        border-top-right-radius: 12px;
        border-top-left-radius: 12px;
        padding: 26px 4vw 0;
        height: 450px;
        `:`
        padding: 0px 40px 0px;
        height: calc(100vh - 340px);;
        overflow: auto;
        `};
    }

    .cate-container {
        height: 360px;
        overflow-y: scroll;
    }

    .title {
        ${isMobileOnly?`
        font-size: 16px;
        //text-align: center;
        margin-bottom: 20px; 
        position: relative;
        `:`
        font-size: 18px;
        margin-bottom: 40px; 
        position: fixed;
        top: 116px;
        `};

        font-weight: bold;
        height: 24px;
        
    }
`;

const ProdBlock = styled.div`
    //padding: 0 20px;
    .container-left {
        float: left;
    }
    .container-right {
        float: right;
        width: calc(100% - 70px);
        //padding-top: 15px;
    }

    .prod-name {
        ${isMobileOnly?`
        font-size: 14px;
        font-weight: 400;
        line-height: 1.4;
        height: 25px;
        overflow: hidden;
        color: #333333;
        margin-bottom: 4px;
        padding: 8px 0;
        width: calc(100% - 60px);
        `:`
        font-size: 14px;
        font-weight: 400;
        line-height: 1.4;
        height: 25px;
        overflow: hidden;
        color: #333333;
        margin-bottom: 4px;
        padding: 8px 0;
        width: calc(100% - 60px);
        `};
    }

    .prod-opt {
        ${isMobileOnly?`
        line-height: 1.33;
        font-size: 12px;
        color: #666666;
        `:`
        line-height: 1.33;
        font-size: 12px;
        color: #666666;
        `};
    }

    .delete {
        font-size: 14px;
        line-height: 1.57;
        color: #111111;
        top: 8px;
        position: relative;
        width: 36px;
        height: 36px;
        background: url(/assets/images/icon/btn_delete.png) center center / auto no-repeat;
    }
    
    
`;

const ProdThumBlock = styled.div`
    ${isMobileOnly?`
    width: 55px;
    height: 55px;
    border-radius: 5px;
    margin-right: 10px;
    background-size: 55px 55px;
    `:`
    width: 55px;
    height: 55px;
    border-radius: 5px;
    margin-right: 10px;
    background-size: 55px 55px;
    `};
    
    background-image : url(${props => props.backgroundimage});
    background-position: center;
`;

const MyEsPopupCartStep4 = ({active, handleClosePopup, handleReceiveFromPopup, esApplyProdList, handlePdClick, handleDeletePd}) => {
    const refbox = useRef(null);
    const refContainer = useRef(null);
    const dispatch = useDispatch();
    const [startY, setStartY] = useState(0);
    const [moveY, setMoveY] = useState(0);
    const [scrollPosition, setScrollPosition] = useState(0);

    useEffect(() => {
        const handleEnd = (e) => {
            if(isMobileOnly&&refbox && refbox.current) {
                if(refbox.current.getBoundingClientRect().top > 100) {
                    refbox.current.classList.add('hide');
                } else {
                    refbox.current.classList.remove('hide');
                }
            }
            //console.log("transitionend = " + JSON.stringify(refbox.current.getBoundingClientRect()));

        }

        document.addEventListener("transitionend", handleEnd);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("transitionend", handleEnd);
        };
    }, []);

    useEffect(() => {
        if(refbox && refbox.current) {
            if(active) {
                refbox.current.classList.remove('hide');
                refbox.current.classList.remove('active-no');
                setTimeout(() => {
                    refbox.current.classList.add('active');
                }, 10);

                if(isMobileOnly) {
                    if(isIOS) {
                        const _scrollPosition = window.pageYOffset;
                        setScrollPosition(_scrollPosition);
                        
                        document.body.style.top = `-${_scrollPosition}px`;
                        document.body.style.position= 'fixed';
                        
                    } else {
                        document.body.style.overflow = 'hidden';
                    }

                } else {
                    document.body.style.overflow = 'hidden';
                }

            } else {
                refbox.current.classList.remove('active');
                refbox.current.classList.add('active-no');

                if(isMobileOnly) {
                    //document.body.style.overflow = 'unset';
                    //document.body.style.position= 'relative';
                    document.body.removeAttribute('style');
                    if(isIOS) {
                        window.scrollTo(0,scrollPosition);
                    }
                    
                } else {
                    //document.body.style.overflow = 'auto';
                    document.body.removeAttribute('style');
                }

            }
        }

    }, [active]);


    const onClick = (e) => {
        e.stopPropagation();
        if(handleClosePopup !== null && handleClosePopup !== undefined) {
            handleClosePopup();
        }

    }

    const onClickContainer = (e) => {

    }

    const click1handler = (id) => {
        
    }

    const click2Handler = (firstId, secondId) => {
        if(handleReceiveFromPopup !== null && handleReceiveFromPopup !== undefined) {
            handleReceiveFromPopup(firstId, secondId);
            if(handleClosePopup !== null && handleClosePopup !== undefined) {
                handleClosePopup();
            }
        }
    }

    const  touchX = (event) => {
        if ("touches" in event && event.touches.length >= 1) {
            const { clientX, clientY } =
            "touches" in event ? event.touches[0] : event;

            return clientX;
          }

          return;
    }

    const touchY = (event) => {
        //return;
        if ("touches" in event && event.touches.length >= 1) {
            const { clientX, clientY } =
            "touches" in event ? event.touches[0] : event;

            return clientY;
        }
        return;
    }

    const touchCancel = (e) => {

    }

    const touchEnd = (e) => {
        if(isMobileOnly && startY > 0) {
            //if(moveY - startY > 70) {
                if(handleClosePopup !== null && handleClosePopup !== undefined) {
                    handleClosePopup();
                }
            //}
        }

        setMoveY(0);
        setStartY(0);
    }

    const touchMove = (e) => {
        if(isMobileOnly && startY > 0) {
            let moveY = touchY(e);
            setMoveY(moveY);
        }
    }

    const touchStart = (e) => {
        if(isMobileOnly && refContainer && refContainer.current){
            let startY = touchY(e);
            //console.log('topY = ' + refContainer.current.getBoundingClientRect().top)

            if(startY - refContainer.current.getBoundingClientRect().top < 40) {
                setStartY(startY);
            }
        }
    }

    const handlePdClick2 = (id) => {
        if(handleClosePopup !== null && handleClosePopup !== undefined) {
            handleClosePopup();
        }
        if(handlePdClick !== null && handlePdClick !== undefined) {
            handlePdClick(id);
        }
        
    }

    const handleDeletePd2 = (item) => {
        if(handleClosePopup !== null && handleClosePopup !== undefined) {
            //handleClosePopup();
        }
        if(handleDeletePd !== null && handleDeletePd !== undefined) {
            handleDeletePd(item);
        }
    }

    if(esApplyProdList === null || esApplyProdList&&esApplyProdList.length < 1) {
        //return <div/>
        if(handleClosePopup !== null && handleClosePopup !== undefined) {
            handleClosePopup();
        }
    }

    return (
        <MyEsPopupCartStep4Block  ref={refbox}>
            <div className="close-pop" /* onMouseDown = {onClick} onTouchStart={onClick}  */onClick={onClick}>&nbsp;</div>
            <MyEsPopupCartStep4ContainerBlock ref={refContainer} onClick={touchStart} onTouchStart={touchStart} onTouchMove={touchMove} onTouchEnd={touchEnd} onTouchCancel={touchCancel}>
                <div className="top-blank "/>
                <div className="top-bar" ></div>
                {
                    <div className="container small_scroll" onClick={onClickContainer}>
                        <div className="title" onClick={onClick}>상품</div>
                        <div className="cate-container">
                        {
                            esApplyProdList&&esApplyProdList.map((item) => {
                                return (
                                    <ProdBlock key={item.prdct_id+""+item.opt_id}className="clearfix">
                                        <div className="clearfix margin_b-20">
                                            <div className="container-left" onClick={()=>handlePdClick2(item.prdct_id)} style={{cursor:'pointer'}}>
                                                    <ProdThumBlock backgroundimage={item.img.replace(/ /g, "%20")} />
                                            </div>
                                            <div className="container-right">
                                                <div className="clearfix" style={{height:'30px'}}>
                                                    <div className="f-left prod-name" onClick={()=>handlePdClick2(item.prdct_id)} style={{cursor:'pointer'}}>
                                                                    {item.prdct_nm}
                                                    </div>
                                                    <div className="f-right delete"onClick={()=>handleDeletePd2(item)} style={{cursor:'pointer'}}/>
                                                </div>
                                                <div >
                                                    <div className="prod-opt" onClick={()=>handlePdClick2(item.prdct_id)} style={{cursor:'pointer'}}>
                                                    {item.opt_nm}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ProdBlock>
                                )
                            }
                            )
                        }
                        </div>
                    </div>
                }
                
            </MyEsPopupCartStep4ContainerBlock>
        </MyEsPopupCartStep4Block>
        
    );
};

export default MyEsPopupCartStep4;